// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class PatrolCasesResource extends Resource {
    basePath: string = 'cases/patrol/';

    objectPath: string = 'cases/patrol/{ident}/';
}
